<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<mat-form-field
  class="chip-list"
  [class.has-chips]="!singleSelect && selectedItems.length > 0"
  appearance="outline"
  [subscriptSizing]="subscriptSizing"
>
  <mat-label>{{ title }}</mat-label>
  
  @if (singleSelect) {
    <!-- Single-select mode: regular input -->
    <input
      [placeholder]="inputPlaceholder"
      #elementsInput
      #singleInput
      [formControl]="control"
      [matAutocomplete]="auto"
      matInput
      [matTooltip]="singleInput.value"
      [matTooltipDisabled]="!isOverflowing(singleInput)"
      (focus)="onSingleInputFocused()"
      (blur)="onSingleInputBlurred()"
    />
  } @else {
    <!-- Multi-select mode: chip grid + chip input -->
    <mat-chip-grid #chipGrid>
      @for (selectedItem of selectedItems; track selectedItem.element.id) {
      <mat-chip-row (removed)="remove(selectedItem)" (click)="onChipClick(selectedItem)">
        <span class="chip-text" #chipText [matTooltip]="selectedItem.element.name" [matTooltipDisabled]="!isOverflowing(chipText)">
          <fa-icon
            *ngIf="selectedItem.groupIcon"
            class="chip-icon"
            [icon]="selectedItem.groupIcon"
          ></fa-icon>
          {{ selectedItem.element.name }}
        </span>
        <button matChipRemove [attr.aria-label]="'remove ' + selectedItem.element.name">
          <fa-icon class="icon chip-remove-icon" [icon]="faXmark"></fa-icon>
        </button>
      </mat-chip-row>
      }
      <input
        [placeholder]="inputPlaceholder"
        #elementsInput
        [formControl]="control"
        [matChipInputFor]="chipGrid"
        [matAutocomplete]="auto"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (click)="onInputClick()"
        (focus)="onInputClick()"
      />
    </mat-chip-grid>
  }
  
  @if (singleSelect) {
    <span matSuffix class="mat-select-arrow-wrapper" [class.arrow-rotated]="isPanelOpen()">
      <span class="mat-select-arrow"></span>
    </span>
  } @else {
    <fa-icon matSuffix [icon]="faMagnifyingGlass" class="search-icon"></fa-icon>
  }
  <mat-autocomplete
    #auto="matAutocomplete"
    class="grouped-chips-panel"
    panelWidth="auto"
    (opened)="onPanelOpened()"
    (optionSelected)="onOptionSelected($event)"
  >
    @for (group of filteredGroups; track group.key; let groupIdx = $index) {
      @if (groupIdx > 0) {
        <mat-divider class="group-divider"></mat-divider>
      }
      @if (showGroupHeaders && group.label) {
        <mat-option disabled class="group-header-option">
          <div class="group-header">
            <fa-icon *ngIf="group.icon" class="group-icon" [icon]="group.icon"></fa-icon>
            <span class="group-label">{{ group.label }}</span>
          </div>
        </mat-option>
      }
      @for (item of group.items; track item.id) {
        <mat-option
          [value]="{ item: item, group: group }"
          class="grouped-option"
          [class.option-disabled]="item.disabled"
          hideSingleSelectionIndicator
        >
          <div class="option-content">
            @if (optionTemplate) {
              <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: item, group: group }"></ng-container>
            } @else {
              <span class="option-text" #optText [matTooltip]="item.displayName || item.name" [matTooltipDisabled]="!isOverflowing(optText)">{{ item.displayName || item.name }}</span>
            }
            <div class="option-right">
              <fa-icon
                *ngIf="isSelected(item, group.key)"
                class="selected-icon"
                [icon]="faCheck"
              ></fa-icon>
            </div>
          </div>
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
